module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry-gift-c4255887f371f0baf1b23704c19eff39.webp";